"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgKeys = function SvgKeys(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.563 10.375a6.063 6.063 0 1 0 5.511 3.532c.892-.835 2.209-2.103 4.097-3.992l.082-.081.17.173c.472.471.843.798 1.126 1.024.522.415 1.19.343 1.665-.083.247-.222.571-.527.985-.941.415-.415.72-.739.941-.986.426-.476.499-1.143.083-1.665A13.643 13.643 0 0 0 21.2 6.23l-.22-.218c.448-.475.784-.843 1.033-1.12.45-.499.697-1.236.249-1.866a5.498 5.498 0 0 0-.596-.693 5.493 5.493 0 0 0-.694-.596c-.63-.449-1.366-.2-1.865.248-.793.713-2.323 2.144-5.021 4.842a177.395 177.395 0 0 0-3.992 4.1 6.042 6.042 0 0 0-2.53-.552Zm2.099 6.063a2.099 2.099 0 1 0-4.198 0 2.099 2.099 0 0 0 4.198 0Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgKeys);
var _default = exports["default"] = Memo;